import { useCallback } from 'react'

import { Navbar as BaseNavbar, Navbar2 as BaseNavbar2 } from 'decentraland-dapps/dist/containers'
import { NavbarPages } from 'decentraland-ui/dist/components/Navbar/Navbar.types'
import { isEmpty } from 'lodash'

import { config } from '../../config/config'
import useDclProfile from '../../hooks/useDclProfile'

import './Navbar.css'
import { Props } from './Navbar.types'

const AUTH_URL = config.get('AUTH_URL')

export default function Navbar(props: Props) {
  const { address, isConnected } = props
  const { profile, isLoadingDclProfile } = useDclProfile(address)
  const hasProfile = !isEmpty(profile)

  const handleSignIn = useCallback(() => {
    window.location.replace(`${AUTH_URL}?redirectTo=${window.location.href}`)
  }, [])

  if (props.isNavbar2Enabled) {
    return (
      <BaseNavbar2
        {...props}
        onSignIn={handleSignIn}
        withNotifications={false}
        activePage={NavbarPages.GOVERNANCE}
        avatar={hasProfile ? profile : undefined}
        isSignedIn={isConnected && hasProfile}
        isSigningIn={isLoadingDclProfile}
      />
    )
  }

  return (
    <BaseNavbar
      {...props}
      onSignIn={handleSignIn}
      withNotifications={false}
      activePage="governance"
      avatar={hasProfile ? profile : undefined}
      isSignedIn={isConnected && hasProfile}
      isSigningIn={isLoadingDclProfile}
    />
  )
}
